export const items = [
  {
    id: 0,
    name: "10",
    img: "quest_ten",
  },
  {
    id: 1,
    name: "J",
    img: "quest_j",
  },
  {
    id: 2,
    name: "Q",
    img: "quest_q",
  },
  {
    id: 3,
    name: "K",
    img: "quest_k",
  },
  {
    id: 4,
    name: "A",
    img: "quest_ace",
  },
  {
    id: 5,
    name: "Samurai",
    img: "quest_major_5",
  },
  {
    id: 6,
    name: "Geisha",
    img: "quest_major_4",
  },
  {
    id: 7,
    name: "Empress",
    img: "quest_major_3",
  },
  {
    id: 8,
    name: "Minister",
    img: "quest_major_2",
  },
  {
    id: 9,
    name: "General",
    img: "quest_major_1",
  },
  {
    id: 10,
    name: "Scatter",
    img: "Scatter",
  },
];
